
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'FileInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object as PropType<string[]>,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: ''
    },
    errorFileType: {
      type: String,
      default: ''
    }
  },
  emits: ['onUpload']
})

